import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';
import { formatPhoneNumber } from '@src/utils/number';
import actions from '@src/redux/actions';

import { StyledUserOrderInfo } from './index.style';

const UserOrderInfo = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const dropdownEl = useRef();
  const { latestOrder } = useSelector((state) => state.user);
  const { user } = useSelector((state) => state.auth);
  const { phoneNumber: phoneNumberState = '' } = useSelector(
    (state) => state.order.userOrder,
  );
  const [showDropdown, setShowDropdown] = useState(false);

  const initPhoneNumber =
    phoneNumberState || user?.phoneNumber || user.firstName;

  const [phoneNumber] = useState(initPhoneNumber);

  const handleClickOutside = useCallback(
    (e) => {
      if (
        showDropdown &&
        e.target.closest('.select-code-country') !== dropdownEl.current
      ) {
        setShowDropdown(false);
      }
    },
    [showDropdown, setShowDropdown, dropdownEl],
  );

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [handleClickOutside]);

  useEffect(() => {
    const data = {};
    if (latestOrder?.user?.phoneNumber) {
      data.phoneNumber = latestOrder?.user?.phoneNumber;
    } else if (user?.phoneNumber) {
      data.phoneNumber = user?.phoneNumber;
    }
    if (user?.firstName || user?.lastName)
      data.user = `${user.lastName || ''} ${user.firstName || ''}`;
    if (user?.email) data.email = user.email;
    dispatch(actions.order.updateUserOrder(data));
  }, []);

  useEffect(() => {
    if (latestOrder?.user?.phoneNumber || user?.phoneNumber) {
      dispatch(
        actions.order.updateUserOrder({
          phoneNumber: latestOrder?.user?.phoneNumber || user?.phoneNumber,
        }),
      );
    }
  }, [latestOrder]);

  const displayPhoneNumber = () => (
    <Box className="user-info-phone-number">
      <span>{formatPhoneNumber(phoneNumber)}</span>
    </Box>
  );

  return (
    <StyledUserOrderInfo>
      <Typography className="info-title">{t('buyerInformation')}</Typography>

      <Box className="user-info-content">
        <Typography className="user-info-item">
          <span className="user-info-item-label">{t('account')}:</span>
          <span>{`${user.lastName || ''} ${user.firstName || ''}`}</span>
        </Typography>
        <Typography className="user-info-item">
          <span className="user-info-item-label" style={{ paddingTop: '3px' }}>
            {t('phoneNumber')}:
          </span>
          <Box className="phone-number-card">{displayPhoneNumber()}</Box>
        </Typography>
      </Box>
    </StyledUserOrderInfo>
  );
};

export default UserOrderInfo;
